// Maps job types to a list of routes

export default {
    'Twitter Stream': ['general-settings', 'stream-criteria', 'scheduling'],
    'Twitter Search': ['general-settings', 'search-criteria', 'scheduling'],
    'Web': ['general-settings', 'url-management', 'scraping-rules', 'crawler-settings', 'scheduling'],
    'ECM': ['general-settings', 'ecm-crawler-settings', 'ecm-annotation-settings', 'scheduling'],
    'RDBMS': ['general-settings', 'rdbms-crawler-settings', 'scheduling'],
    'Local Documents': ['general-settings', 'local-documents']
};
